module.exports = __webpack_public_path__ + "static/6-b07f32fbc72b19a89018e3f5c73d9ec9.jpg";